import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  BreadcrumbModule,
  DropdownModule,
  EmptyStateModule,
  IconModule,
  LoaderModule,
  LogoModule,
  ModalModule,
  NavbarModule,
  SidebarModule,
  TableModule
} from '@michelin/theme';

const modules = [
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  BreadcrumbModule,
  DropdownModule,
  ModalModule,
  SidebarModule,
  NavbarModule,
  LogoModule,
  LoaderModule,
  IconModule,
  TableModule,
  EmptyStateModule
];

@NgModule({
  imports: [...modules],
  declarations: [],
  exports: [...modules],
  providers: []
})
export class SharedModule {}
